import { render, staticRenderFns } from "./task-attachment-form.vue?vue&type=template&id=953e6d7e&"
import script from "./task-attachment-form.vue?vue&type=script&lang=js&"
export * from "./task-attachment-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('953e6d7e')) {
      api.createRecord('953e6d7e', component.options)
    } else {
      api.reload('953e6d7e', component.options)
    }
    module.hot.accept("./task-attachment-form.vue?vue&type=template&id=953e6d7e&", function () {
      api.rerender('953e6d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-attachment-form.vue"
export default component.exports